import { useState, useEffect } from 'react';

const urlObjectToString = (url) => {
  return typeof url === "string" ? url : `${String(url.pathname)}${String(url.search)}${String(url.hash)}`;
};
function useCompatRouter() {
  const [customRouter, setCustomRouter] = useState(null);
  useEffect(() => {
    const parseQuery = () => {
      const query = {};
      const searchParams = new URLSearchParams(window.location.search);
      for (const [key, value] of searchParams.entries()) {
        query[key] = value;
      }
      return query;
    };
    const initialRouter = {
      route: window.location.pathname,
      pathname: window.location.pathname,
      query: parseQuery(),
      asPath: window.location.pathname + window.location.search,
      basePath: "",
      locale: void 0,
      locales: void 0,
      defaultLocale: void 0,
      domainLocales: void 0,
      isLocaleDomain: false,
      push: (url) => {
        window.history.pushState({}, "", urlObjectToString(url));
        window.dispatchEvent(new Event("popstate"));
        return Promise.resolve(true);
      },
      replace: (url) => {
        window.history.replaceState({}, "", urlObjectToString(url));
        window.dispatchEvent(new Event("popstate"));
        return Promise.resolve(true);
      },
      reload: () => {
        window.location.reload();
      },
      back: () => {
        window.history.back();
      },
      forward: () => {
        window.history.forward();
      },
      prefetch: () => {
        return Promise.resolve();
      },
      beforePopState: () => {
      },
      events: {
        on: () => {
        },
        off: () => {
        },
        emit: () => {
        }
      },
      get isFallback() {
        return false;
      },
      get isPreview() {
        return false;
      },
      isReady: true
    };
    setCustomRouter(initialRouter);
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      setCustomRouter((prevRouter) => ({
        ...prevRouter,
        route: window.location.pathname,
        pathname: window.location.pathname,
        query: (() => {
          const query = {};
          const searchParams = new URLSearchParams(window.location.search);
          for (const [key, value] of searchParams.entries()) {
            query[key] = value;
          }
          return query;
        })(),
        asPath: window.location.pathname + window.location.search
      }));
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  if (customRouter) {
    return customRouter;
  } else {
    return {
      route: "",
      pathname: "",
      query: {},
      asPath: "",
      basePath: "",
      locale: void 0,
      locales: void 0,
      defaultLocale: void 0,
      domainLocales: void 0,
      isLocaleDomain: false,
      push: () => Promise.resolve(true),
      replace: () => Promise.resolve(true),
      reload: () => {
      },
      back: () => {
      },
      forward: () => {
      },
      prefetch: () => Promise.resolve(),
      beforePopState: () => {
      },
      events: {
        on: () => {
        },
        off: () => {
        },
        emit: () => {
        }
      },
      get isFallback() {
        return false;
      },
      get isPreview() {
        return false;
      },
      isReady: false
    };
  }
}

export { useCompatRouter };
//# sourceMappingURL=useRouter.js.map
